export default {

	methods: {
        saveSettings(action = null) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return false
                } else {
                    let data = {model: this.model}
                    _.forEach(this.settings, (value, key) => {
                        data[key] = value == undefined ? null : value
                    })

                    this.axios.post('settings/', data).then(response => {
                        // get body data
                        this.$store.commit('setSnackbar', {timeout: 6000, text: 'Impostazioni salvate', value: true, color: 'success'})
                        this.$store.commit('SET_SETTINGS', response.data.settings)
                        
                        if(action == 'reload') {
                            window.location.reload(true)
                        }
                    }, response => {
                        // error callback
                    })
                }
            }).catch(() => {

            })
        },

        infoSettingsPrint() {
		    this.axios.post('layouts/', {'model': this.model}).then(response => {

                this.layouts = response.data.layouts
 
                 this.axios.get('settings/'+this.model+'/layout').then(response => {
 
                     _.forEach(response.data.settings, (setting) => {
                         this.settings[setting.key] = setting.value
                     })
                     this.$store.commit('endProgress')
 
                 }, response => {
                     // error callback
                 })
             }, response => {
                 // error callback
             })
        }
    },
    
    created() {
        if(!this.model) {
            this.$store.commit('endProgress')
            return
        }
        this.axios.get('settings/'+this.model).then(response => {

            _.forEach(response.data.settings, (setting) => {
                if(setting.key == 'logo') {
                    this.settings['logo'] = setting.id
                } else {
                    this.$set(this.settings, setting.key, setting.value)
                }
            })
            this.$store.commit('endProgress')

        }, response => {
            // error callback
        })
    }
}